// !important: This file couldn't be reused in Nuxt so double check when doing changes in the file.

/**
 * Test if the browser supports the narrow currency symbol.
 *
 * @param {string} currency
 * @returns {object}
 */
export function narrowSymbolTest(currency = 'EUR') {
    try {
        return new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency,
            currencyDisplay: 'narrowSymbol',
        })
    } catch (e) {
        if (e.constructor !== RangeError) {
            throw e
        }
        return null
    }
}
